import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { YardMapComponent } from './component/yardmap.component';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [
    YardMapComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class YardMapModule { }
